module.exports = __webpack_public_path__ + "static/media/AWS-SolArchitect-Associate.7aa06c03.png";